import * as React from 'react';
import clx from 'classnames';
import { Button, Typography } from 'antd';
import { ButtonProps } from 'antd/lib/button';

export interface ProcedureSaveButtonProps extends ButtonProps {}

/**
 * Pulsante per il salvataggio in bozza dell'istanza
 */
export function ProcedureSaveButton(props: ProcedureSaveButtonProps) {
  const { ...buttonProps } = props;

  return (
    <Button block size="large" {...buttonProps}>
      Salva Istanza
    </Button>
  );
}
